import React from "react";
import Slider, { Settings } from "react-slick";

import shape1 from "../../images/testimonial/img-3.jpg";
import shape2 from "../../images/testimonial/img-4.jpg";

interface TestimonialItem {
  id: string;
  Des: string;
  Title: string;
  Date: string;
}

const testimonials: TestimonialItem[] = [
  {
    id: "01",
    Des: "Planning a wedding felt overwhelming until we met Bohu. Their team took our ideas and transformed them into a celebration beyond what we could have imagined. Truly professional, creative, and supportive throughout the journey.",
    Title: "Marlin & Williamson",
    Date: "23.05.2025",
  },
  {
    id: "02",
    Des: "Planning a wedding felt overwhelming until we met Bohu. Their team took our ideas and transformed them into a celebration beyond what we could have imagined. Truly professional, creative, and supportive throughout the journey.",
    Title: "Rihanna & William",
    Date: "08.12.2025",
  },
  {
    id: "03",
    Des: "Planning a wedding felt overwhelming until we met Bohu. Their team took our ideas and transformed them into a celebration beyond what we could have imagined. Truly professional, creative, and supportive throughout the journey.",
    Title: "Sarah & Daniel",
    Date: "12.08.2025",
  },
];

// Component
const Testimonial2: React.FC = () => {
  const settings: Settings = {
    dots: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <section className="wpo-testimonial-section-s2 section-padding">
      <div className="container-fluid">
        <div className="wpo-testimonial-wrap">
          <div className="row justify-content-center">
            <div
              className="col col-xl-8 col-lg-8 col-12 wow fadeInUp"
              data-wow-duration="1700ms"
            >
              <div className="wpo-testimonial-items">
                <div className="wpo-testimonial-active">
                  <Slider {...settings}>
                    {testimonials.map((testimonial) => (
                      <div
                        className="wpo-testimonial-item"
                        key={testimonial.id}
                      >
                        <div className="wpo-testimonial-text">
                          <i className="ti-quote-right"></i>
                          <p>"{testimonial.Des}"</p>
                          <div className="wpo-testimonial-text-btm">
                            <h3>{testimonial.Title}</h3>
                            <span>Wedding - {testimonial.Date}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background floating images */}
      <div
        className="image image-move wow zoomIn"
        data-wow-duration="1200ms"
      >
        <img src={shape1} alt="testimonial decoration" />
      </div>
      <div
        className="image s2 image-move wow zoomIn"
        data-wow-duration="1200ms"
      >
        <img src={shape2} alt="testimonial decoration 2" />
      </div>
    </section>
  );
};

export default Testimonial2;
